import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatOptgroup, MatOption, MatSelect } from '@angular/material/select';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { UserSignatureSelectedService } from '../../../../shared/services/user-signature-selected.service';
import { ReferenceSignaturesService } from '../../../../shared/services/reference-signatures.service';
import { UserCountrySelectedService } from '../../../../shared/services/user-country-selected.service';
import { UserDashboardViewSelectedService } from '../../../../shared/services/user-dashboard-view-selected.service';
import { DashboardViewEnum } from '../../../../shared/enum/dashboard-view.enum';
import { FieldLabelContainerComponent } from '../../../../shared/components/field/field-label-container/field-label-container.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { UserManagementService } from '../../../user-management/services/user-management.service';
import { AdUserModel } from '../../../user-management/models/adUser.model';
import { ReferenceSignatureModel } from '../../../../shared/models/reference-signature.model';

@Component({
  selector: 'app-select-signature',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatSelect,
    MatOption,
    NgIf,
    MatInputModule,
    NgForOf,
    MatOptgroup,
    FieldLabelContainerComponent,
    ButtonComponent,
    AsyncPipe,
  ],
  templateUrl: './select-signature.component.html',
  styleUrl: './select-signature.component.scss',
})
export class SelectSignatureComponent implements OnInit {
  signatureSelectForm?: FormGroup;

  referenceSignatureList$ = combineLatest([
    this.userManagementService.getCurrentUserDetails(),
    this.referenceSignatureService.getList(),
  ]).pipe(
    map(([userInfo, signatureList]: [AdUserModel | undefined, ReferenceSignatureModel[]]) =>
      this.referenceSignatureService.filterListForUser(signatureList, userInfo)
    )
  );

  constructor(
    private _router: Router,
    private userSignatureSelectedService: UserSignatureSelectedService,
    private userCountrySelectedService: UserCountrySelectedService,
    private referenceSignatureService: ReferenceSignaturesService,
    private userDashboardViewSelectedService: UserDashboardViewSelectedService,
    private userManagementService: UserManagementService
  ) {}

  ngOnInit(): void {
    this.signatureSelectForm = new FormGroup({
      referenceSignatureSelected: new FormControl('', Validators.required),
    });

    this.userSignatureSelectedService.userSignatureIdSelectedSubject$.subscribe(
      () => {
        const selectedReferenceSignatureInfo =
          this.userSignatureSelectedService.getUserSignatureInfoSelected();

        const referenceSignatureSelectedId = this.signatureSelectForm?.get(
          'referenceSignatureSelected'
        )!.value;

        if (selectedReferenceSignatureInfo && !referenceSignatureSelectedId) {
          this.signatureSelectForm
            ?.get('referenceSignatureSelected')!
            .patchValue(selectedReferenceSignatureInfo);
        }
      }
    );
  }

  onSubmit() {
    if (this.signatureSelectForm!.valid) {
      const referenceSignatureSelectedId =
        this.signatureSelectForm!.value.referenceSignatureSelected;

      this.userSignatureSelectedService.updateUserSignatureSelected(
        referenceSignatureSelectedId
      );
      this.userCountrySelectedService.updateUserCountrySelected('AE');

      /*      this._router.navigate(['/dashboard/global']).then(() => {
        this.userDashboardViewSelectedService.updateUserDashboardViewSelected(
          DashboardViewEnum.DashboardViewGlobal
        );
      });*/

      this._router.navigate(['/dashboard/user-management']).then(() => {
        this.userDashboardViewSelectedService.updateUserDashboardViewSelected(
          DashboardViewEnum.DashboardViewGlobal
        );
      });
    }
  }
}
